module.exports = __webpack_public_path__ + "img/羌活.82dd7449.jpg";